module.exports = __webpack_public_path__ + "static/img/deflault_logo.702bcdcc.png";